module.exports = __webpack_public_path__ + "assets/img/ecb968d8b1aef141db8884bb8b380e8e.svg";